module.exports = __webpack_public_path__ + "img/denonaB3.84878399.jpg";